import CourseList from './CourseList'

const exportObj = {
    CourseList
}

export default exportObj